"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecutableOperation = void 0;
const transaction_1 = require("../../transaction");
const transaction_2 = require("../transaction");
const operation_1 = require("./operation");
class ExecutableOperation {
    provider;
    status = operation_1.NetworkOperationStatus.Initializing;
    receipts = [];
    constructor(provider) {
        this.provider = provider;
    }
    async trackEVMTransaction(chainId, transactionHash, type = transaction_2.TransactionType.Base) {
        const api = this.provider.jevmApi[chainId];
        const receipt = new transaction_2.TransactionReceipt(api.chain.id, type, transaction_1.EVMTransactionStatus.Pending, transactionHash);
        this.receipts.push(receipt);
        const transactionStatus = await new transaction_1.EVMTransactionStatusFetcher(api, transactionHash).fetch(transaction_2.WalletStatusFetcherTimeout, transaction_2.WalletStatusFetcherDelay);
        receipt.transactionStatus = transactionStatus;
        if (transactionStatus === transaction_1.EVMTransactionStatus.Failure) {
            this.status = operation_1.NetworkOperationStatus.Error;
        }
        else if (transactionStatus !== transaction_1.EVMTransactionStatus.Success) {
            this.status = operation_1.NetworkOperationStatus.Timeout;
        }
        return transactionStatus === transaction_1.EVMTransactionStatus.Success;
    }
    async trackJEVMTransaction(chainId, transactionId, type = transaction_2.TransactionType.Base) {
        const api = this.provider.jevmApi[chainId];
        const receipt = new transaction_2.TransactionReceipt(api.chain.id, type, transaction_1.JEVMTransactionStatus.Processing, transactionId);
        this.receipts.push(receipt);
        const transactionStatus = await new transaction_1.JEVMTransactionStatusFetcher(api, transactionId).fetch(transaction_2.WalletStatusFetcherTimeout, transaction_2.WalletStatusFetcherDelay);
        receipt.transactionStatus = transactionStatus;
        if (transactionStatus === transaction_1.JEVMTransactionStatus.Dropped) {
            this.status = operation_1.NetworkOperationStatus.Error;
        }
        else if (transactionStatus !== transaction_1.JEVMTransactionStatus.Accepted) {
            this.status = operation_1.NetworkOperationStatus.Timeout;
        }
        return transactionStatus === transaction_1.JEVMTransactionStatus.Accepted;
    }
    async trackPlatformTransaction(transactionId, type = transaction_2.TransactionType.Base) {
        const receipt = new transaction_2.TransactionReceipt(this.provider.platformChain.id, type, transaction_1.PlatformTransactionStatus.Processing, transactionId);
        this.receipts.push(receipt);
        const transactionStatus = await new transaction_1.PlatformTransactionStatusFetcher(this.provider.platformApi, transactionId).fetch(transaction_2.WalletStatusFetcherTimeout, transaction_2.WalletStatusFetcherDelay);
        receipt.transactionStatus = transactionStatus;
        if (transactionStatus === transaction_1.PlatformTransactionStatus.Dropped ||
            transactionStatus === transaction_1.PlatformTransactionStatus.Aborted) {
            this.status = operation_1.NetworkOperationStatus.Error;
        }
        else if (transactionStatus !== transaction_1.PlatformTransactionStatus.Committed) {
            this.status = operation_1.NetworkOperationStatus.Timeout;
        }
        return transactionStatus === transaction_1.PlatformTransactionStatus.Committed;
    }
    async trackJVMTransaction(transactionId, type = transaction_2.TransactionType.Base) {
        const receipt = new transaction_2.TransactionReceipt(this.provider.jvmChain.id, type, transaction_1.JVMTransactionStatus.Processing, transactionId);
        this.receipts.push(receipt);
        const transactionStatus = await new transaction_1.JVMTransactionStatusFetcher(this.provider.jvmApi, transactionId).fetch(transaction_2.WalletStatusFetcherTimeout, transaction_2.WalletStatusFetcherDelay);
        receipt.transactionStatus = transactionStatus;
        if (transactionStatus === transaction_1.JVMTransactionStatus.Unknown) {
            this.status = operation_1.NetworkOperationStatus.Error;
        }
        else if (transactionStatus !== transaction_1.JVMTransactionStatus.Accepted) {
            this.status = operation_1.NetworkOperationStatus.Timeout;
        }
        return transactionStatus === transaction_1.JVMTransactionStatus.Accepted;
    }
}
exports.ExecutableOperation = ExecutableOperation;
